import { createAction } from '@reduxjs/toolkit'
import { Address, PaymentMethod } from '../../../shared/types/battery'
import { AppliedCoupon } from '../../../shared/utils/couponHelpers'
import { ShippingOption } from '../../../types/api'
import { CheckoutState } from './types'

/**
 * Actions do módulo Checkout
 */
export const checkoutActions = {
  // Step management
  setCurrentStep: createAction<number>('checkout/setCurrentStep'),
  nextStep: createAction('checkout/nextStep'),
  prevStep: createAction('checkout/prevStep'),
  
  // Address management
  setShippingAddress: createAction<Address>('checkout/setShippingAddress'),
  setBillingAddress: createAction<Address>('checkout/setBillingAddress'),
  setSelectedAddressId: createAction<string | null>('checkout/setSelectedAddressId'),
  setShowNewAddressForm: createAction<boolean>('checkout/setShowNewAddressForm'),
  setAddressConfirmed: createAction<boolean>('checkout/setAddressConfirmed'),
  
  // Customer info
  setCustomerInfo: createAction<{ email?: string; name?: string; document?: string }>('checkout/setCustomerInfo'),
  
  // Shipping
  calculateShippingRequest: createAction<Address>('checkout/calculateShippingRequest'),
  calculateShippingSuccess: createAction<{ options: ShippingOption[] }>('checkout/calculateShippingSuccess'),
  calculateShippingFailure: createAction<{ error: string }>('checkout/calculateShippingFailure'),
  setSelectedShippingOption: createAction<string | null>('checkout/setSelectedShippingOption'),
  
  // Coupons
  applyCouponRequest: createAction<{ code: string; subtotal: number }>('checkout/applyCouponRequest'),
  applyCouponSuccess: createAction<{ coupon: AppliedCoupon }>('checkout/applyCouponSuccess'),
  applyCouponFailure: createAction<{ error: string }>('checkout/applyCouponFailure'),
  removeCoupon: createAction<string>('checkout/removeCoupon'),
  clearCoupons: createAction('checkout/clearCoupons'),
  setCouponCode: createAction<string>('checkout/setCouponCode'),
  
  // Payment
  setPaymentMethod: createAction<PaymentMethod | null>('checkout/setPaymentMethod'),
  createPaymentIntentRequest: createAction<{ amount: number; paymentMethod: PaymentMethod }>('checkout/createPaymentIntentRequest'),
  createPaymentIntentSuccess: createAction<{ clientSecret: string }>('checkout/createPaymentIntentSuccess'),
  createPaymentIntentFailure: createAction<{ error: string }>('checkout/createPaymentIntentFailure'),
  setShowPaymentForm: createAction<boolean>('checkout/setShowPaymentForm'),
  setPaymentProcessed: createAction<boolean>('checkout/setPaymentProcessed'),
  
  // Order
  createOrderRequest: createAction<any>('checkout/createOrderRequest'),
  createOrderSuccess: createAction<{ orderId: string }>('checkout/createOrderSuccess'),
  createOrderFailure: createAction<{ error: string }>('checkout/createOrderFailure'),
  
  // Form errors
  setFormErrors: createAction<Record<string, string>>('checkout/setFormErrors'),
  clearFormErrors: createAction('checkout/clearFormErrors'),
  
  // Reset checkout
  resetCheckout: createAction('checkout/resetCheckout'),
  
  // Load from storage
  loadCheckoutData: createAction<Partial<CheckoutState>>('checkout/loadCheckoutData'),
}

